import { User } from "src/services/ApiClient/users";

export const getCurrentUser = (state): User =>
  state.homeReducer.currentUser ?? null;

export const userHasPhoneNumber = (state): boolean =>
  state.homeReducer.hasPhoneNumber ?? false;
